import React, { useState } from 'react';
import styled from 'styled-components';
import { Box, Button } from '@goodrx/matisse-react';
import { truncateWords } from '@goodrx/x-core';
import { BlockConfig } from '../../../BlockConfig';
import { MarkdownCopy } from '../../../../components/MarkdownCopy';
const StyledConfigBlock = styled(BlockConfig)`
  display: block;
  width: 100%;

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    flex: 1 1 auto;
  }
`;
const StyledMarkdown = styled(MarkdownCopy)`
  width: 100%;

  *:last-child {
    margin-bottom: 0;
  }
`;
export const TextBlock = ({
  className,
  text,
  mobileConfig,
  tabletConfig,
  truncatedWordsCount,
  readMoreCopy
}) => {
  const [readMore, setReadMore] = useState(false);
  const mobileConfigWithDefault = { ...(mobileConfig || {}),
    marginBottom: mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.marginBottom
  };
  const tabletConfigWithDefault = { ...(tabletConfig || {}),
    marginBottom: tabletConfig === null || tabletConfig === void 0 ? void 0 : tabletConfig.marginBottom
  };
  const truncatedText = truncatedWordsCount && !readMore ? truncateWords(text || '', truncatedWordsCount) : text || '';
  return /*#__PURE__*/React.createElement(StyledConfigBlock, {
    className: className,
    mobileConfig: mobileConfigWithDefault,
    tabletConfig: tabletConfigWithDefault
  }, /*#__PURE__*/React.createElement(Box, {
    width: "100%"
  }, /*#__PURE__*/React.createElement(StyledMarkdown, {
    source: truncatedText
  }), !readMore && truncatedWordsCount && /*#__PURE__*/React.createElement(Button, {
    onClick: () => setReadMore(true),
    pl: 0,
    variant: "primaryText"
  }, readMoreCopy || 'Read More')));
};